<div class="dashboard-container">
  <main class="dashboard-content">
    <div
      class="readings-meter-wrap"
      [ngClass]="filteredMeters().length > 1 ? 'reading-container' : 'reading-container mb-3'"
    >
      @if (initialLoading()) {
        <div class="meter-bar readings-meter-skeleton" aria-busy="true">
          <div class="meter-section info">
            <p-skeleton shape="circle" size="20px" />
            <div class="meta">
              <p-skeleton width="55%" height="12px" styleClass="mb-2" />
              <p-skeleton width="65%" height="16px" />
            </div>
          </div>
          <div class="meter-section details">
            <p-skeleton width="70%" height="12px" />
          </div>
          <div class="meter-section value">
            <p-skeleton width="80px" height="14px" />
          </div>
        </div>
      } @else if (filteredMeters().length > 0) {
        @if (!isNarrowViewport()) {
          <p-carousel
            [value]="filteredMeters()"
            [page]="currentPage()"
            (onPage)="onMeterSliderChange($event)"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="false"
            [showIndicators]="filteredMeters().length > 1"
            [showNavigators]="filteredMeters().length > 1"
            styleClass="compact-carousel"
          >
            <ng-template let-meter pTemplate="item">
              <div class="meter-bar">
                <div class="meter-section info">
                  <div class="icon-box">
                    <lucide-icon
                      name="Activity"
                      [style.color]="getColorByType()"
                      [size]="18"
                    ></lucide-icon>
                  </div>
                  <div class="meta">
                    <span class="eyebrow">Última lectura liquidada</span>
                    <div class="title-row">
                      @if (
                        configForm.get('supplyType')?.value?.supplyName != null &&
                        configForm.get('supplyType')?.value?.supplyName != ''
                      ) {
                        <strong [style.color]="getColorByType()">{{
                          configForm.get('supplyType')?.value?.supplyName
                        }}</strong>
                      }
                      @if (meter.serialNumber != null && meter.serialNumber != '') {
                        <span class="serial">Nº de contador: {{ meter.serialNumber }}</span>
                      }
                    </div>
                  </div>
                </div>

                <div class="meter-section details">
                  @if (meter.location != null && meter.location != '') {
                    <div class="detail-item">
                      <lucide-icon name="MapPin" [size]="14"></lucide-icon>
                      <span>{{ meter.location }}</span>
                    </div>
                  }
                  @if (meter.lastReadingDate != null && meter.lastReadingDate != '') {
                    <div class="divider"></div>
                    <div class="detail-item">
                      <lucide-icon name="Calendar" [size]="14"></lucide-icon>
                      <span>{{ dateSpanishFormat(meter.lastReadingDate) }}</span>
                    </div>
                  }
                </div>

                <div class="meter-section value">
                  @if (meter.lastReadingValue != null && meter.lastReadingValue != '') {
                    <div class="value-wrapper">
                      <span class="number" [style.color]="getColorByType()">{{
                        meter.lastReadingValue
                      }}</span>
                      <span class="unit" [style.color]="getColorByType()">{{
                        meter.consumptionUnits
                      }}</span>
                    </div>
                  }
                </div>
              </div>
            </ng-template>
          </p-carousel>
        } @else {
          <p-carousel
            [value]="filteredMeters()"
            [page]="currentPage()"
            (onPage)="onMeterSliderChange($event)"
            [numVisible]="1"
            [numScroll]="1"
            [circular]="false"
            [showIndicators]="filteredMeters().length > 1"
            [showNavigators]="filteredMeters().length > 1"
            styleClass="compact-carousel-mobile"
          >
            <ng-template let-meter pTemplate="item">
              <div class="meter-bar-mobile">
                <div class="meter-bar-mobile__top">
                  <div class="meter-bar-mobile__icon">
                    <lucide-icon
                      name="Activity"
                      [style.color]="getColorByType()"
                      [size]="16"
                    ></lucide-icon>
                  </div>
                  <div class="meter-bar-mobile__meta">
                    <span class="meter-bar-mobile__eyebrow">Última lectura liquidada</span>
                    @if (
                      configForm.get('supplyType')?.value?.supplyName != null &&
                      configForm.get('supplyType')?.value?.supplyName != ''
                    ) {
                      <strong class="meter-bar-mobile__supply" [style.color]="getColorByType()">{{
                        configForm.get('supplyType')?.value?.supplyName
                      }}</strong>
                    }
                  </div>
                </div>

                @if (meter.serialNumber != null && meter.serialNumber != '') {
                  <p class="meter-bar-mobile__serial">Nº de contador: {{ meter.serialNumber }}</p>
                }

                @if (meter.location != null && meter.location != '') {
                  <div class="meter-bar-mobile__row">
                    <lucide-icon name="MapPin" [size]="14"></lucide-icon>
                    <span>{{ meter.location }}</span>
                  </div>
                }

                @if (meter.lastReadingDate != null && meter.lastReadingDate != '') {
                  <div class="meter-bar-mobile__row">
                    <lucide-icon name="Calendar" [size]="14"></lucide-icon>
                    <span>{{ dateSpanishFormat(meter.lastReadingDate) }}</span>
                  </div>
                }

                @if (meter.lastReadingValue != null && meter.lastReadingValue != '') {
                  <div class="meter-bar-mobile__value">
                    <span class="meter-bar-mobile__number" [style.color]="getColorByType()">{{
                      meter.lastReadingValue
                    }}</span>
                    <span class="meter-bar-mobile__unit" [style.color]="getColorByType()">{{
                      meter.consumptionUnits
                    }}</span>
                  </div>
                }
              </div>
            </ng-template>
          </p-carousel>
        }
      }
    </div>

    <div class="top-grid">
      <div [hidden]="consumptions().length == 0 && !initialLoading()" class="kpi-hero">
        <div class="card main-kpi readings-chart-card">
          <div
            [hidden]="configForm.controls['supplyType']?.value?.supplyTypeId == 14"
            #chartContainer
            class="chartContainer"
          ></div>

          <ng-container *ngIf="configForm.controls['supplyType']?.value?.supplyTypeId == 14">
            <div
              [hidden]="configForm.controls['formatType'].value !== 'Consumo individual'"
              #chartContainer2
              class="chartContainer2"
            ></div>

            <div
              [hidden]="configForm.controls['formatType'].value !== 'Consumo desglosado'"
              #chartContainerDistributed
              class="chartContainerDistributed"
            ></div>
          </ng-container>

          @if (initialLoading()) {
            <div class="readings-chart-skeleton" aria-busy="true">
              <p-skeleton width="100%" height="100%" borderRadius="4px" />
            </div>
          }
        </div>
      </div>

      @if (consumptions().length == 0 && !initialLoading()) {
        <div class="empty-insight">
          @if (loading == false) {
            <lucide-icon name="trending-down" [size]="36"></lucide-icon>

            <h3>No hay consumo en este periodo</h3>

            <p>Este suministro no tiene registros en las fechas seleccionadas.</p>

            <div class="suggestions">
              <span>
                <lucide-icon name="lightbulb" [size]="16"></lucide-icon>
                Sugerencias:</span
              >
              <ul>
                <li>Amplía o modifica el rango de fechas</li>
                <li>Verifica el suministro seleccionado</li>
                <li>Verifica el contador seleccionado</li>
              </ul>
            </div>
          }
        </div>
      }
      <div class="side-panel-2 readings-config-wrap">
        <div class="config-container" [formGroup]="configForm">
          <header class="panel-header">
            <lucide-icon name="Settings2" [size]="20"></lucide-icon>
            <h3>Panel de configuración</h3>
          </header>
          <section class="form-section">
            <div class="field mb-4">
              <label class="block mb-1 text-sm font-medium text-secondary"
                >Tipo de Suministro</label
              >
              <p-select
                [options]="supplies()"
                formControlName="supplyType"
                optionLabel="supplyName"
                placeholder="Seleccione suministro"
                class="w-full custom-select"
                (onChange)="onSupplyTypeChange($event, false)"
                appendTo="body"
              >
                <ng-template #selectedItem let-selectedOption>
                  <div class="flex align-items-center gap-2" *ngIf="selectedOption">
                    <lucide-icon name="Droplets" [size]="14"></lucide-icon>
                    <span>{{ selectedOption.supplyName }}</span>
                  </div>
                </ng-template>
              </p-select>
            </div>

            @if (this.configForm.controls['supplyType']?.value?.supplyTypeId != 14) {
              <div class="field mb-4">
                <label class="block mb-1 text-sm font-medium text-secondary"
                  >Contador / Ubicación</label
                >
                <p-select
                  [options]="meters()"
                  formControlName="meter"
                  optionLabel="serialNumber"
                  placeholder="Seleccione contador"
                  class="w-full custom-select"
                  (onChange)="onMeterChange($event)"
                  [emptyMessage]="
                    configForm.get('supplyType')?.value
                      ? 'No hay contadores'
                      : 'Seleccione un suministro primero'
                  "
                  appendTo="body"
                >
                  <ng-template #selectedItem let-selectedOption>
                    @if (selectedOption) {
                      <div
                        class="flex justify-content-between w-full align-items-center"
                        style="gap: 1rem"
                      >
                        <span class="font-medium"
                          >Nº de contador: {{ selectedOption.serialNumber }}</span
                        >
                      </div>
                    }
                  </ng-template>
                  <ng-template #item let-meter>
                    <div class="meter-item flex flex-column w-full gap-1">
                      <div class="flex justify-content-between text-xs text-secondary">
                        <span class="m-sn"> Nº de contador: {{ meter.serialNumber }} </span>
                        <span class="m-sn">
                          Fecha de la lectura: {{ dateSpanishFormat(meter.lastReadingDate) }}
                        </span>
                      </div>
                      <div class="flex justify-content-between text-xs text-secondary">
                        <span class="m-loc">Ubicación del contador: {{ meter.location }}</span>

                        <span class="m-loc font-medium">
                          Lectura acumulada: {{ meter.lastReadingValue }}
                          {{ meter.consumptionUnits }}
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </p-select>
              </div>
            }

            @if (this.configForm.controls['supplyType']?.value?.supplyTypeId == 14) {
              <div class="field mb-4">
                <label class="block mb-1 text-sm font-medium text-secondary"
                  >Visualización del consumo</label
                >
                <p-select
                  [options]="distributionType"
                  formControlName="formatType"
                  placeholder="Seleccione cómo desea ver el consumo"
                  class="w-full custom-select"
                  (onChange)="onSelectDistributionType($event)"
                  [emptyMessage]="
                    configForm.get('formatType')?.value
                      ? ''
                      : 'Seleccione como desea ver el consumo'
                  "
                  appendTo="body"
                >
                  <ng-template #selectedItem let-selectedOption>
                    @if (selectedOption) {
                      <div class="flex align-items-center gap-2">
                        <span class="font-medium">{{ selectedOption }}</span>
                      </div>
                    }
                  </ng-template>

                  <ng-template #item let-type>
                    <div class="meter-item flex flex-column w-full gap-1">
                      <div class="flex justify-content-between text-xs text-secondary">
                        <span class="m-loc">
                          {{
                            type === 'Consumo desglosado'
                              ? 'Comparativa de todos los contadores'
                              : 'Detalle histórico de un dispositivo'
                          }}
                        </span>
                        <span class="m-loc font-medium text-primary">
                          {{
                            type === 'Consumo desglosado'
                              ? 'Consumo desglosado'
                              : 'Consumo
                                                individual'
                          }}
                        </span>
                      </div>
                    </div>
                  </ng-template>
                </p-select>
              </div>
              @if (this.configForm.controls['formatType']?.value == 'Consumo individual') {
                <div class="field mb-4">
                  <label class="block mb-1 text-sm font-medium text-secondary"
                    >Contador / Ubicación</label
                  >
                  <p-select
                    [options]="meters()"
                    formControlName="meter"
                    optionLabel="meterId"
                    placeholder="Seleccione contador"
                    class="w-full custom-select"
                    (onChange)="onMeterChange($event)"
                    [emptyMessage]="
                      configForm.get('supplyType')?.value
                        ? 'No hay contadores'
                        : 'Seleccione un suministro primero'
                    "
                    appendTo="body"
                  >
                    <ng-template #selectedItem let-selectedOption>
                      @if (selectedOption) {
                        <div
                          class="flex justify-content-between w-full align-items-center"
                          style="gap: 1rem"
                        >
                          <span class="font-medium"
                            >Nº de contador: {{ selectedOption.serialNumber }}</span
                          >
                          @if (selectedOption.meterLocation) {
                            <span class="text-sm text-secondary"
                              >({{ selectedOption.meterLocation }})</span
                            >
                          }
                        </div>
                      }
                    </ng-template>

                    <ng-template #item let-meter>
                      <div class="meter-item flex flex-column w-full gap-1">
                        <div class="flex justify-content-between text-xs text-secondary">
                          <span class="m-sn">
                            <strong>Nº de contador:</strong> {{ meter.serialNumber }}
                          </span>
                          <span class="m-sn">
                            <strong>Fecha de la lectura:</strong>
                            {{ dateSpanishFormat(meter.lastReadingDate) }}
                          </span>
                        </div>
                        <div class="flex justify-content-between text-xs text-secondary">
                          @if (meter.meterLocation) {
                            <span class="m-loc"
                              >Ubicación del contador: {{ meter.meterLocation }}</span
                            >
                          }
                          <span class="m-loc font-medium">
                            Lectura acumulada: {{ spanishFormat(meter.consumptionValueTotal) }}
                            {{ meter.consumptionUnits }}
                          </span>
                        </div>
                      </div>
                    </ng-template>
                  </p-select>
                </div>
              }
            }
            @if (showCalendar === true) {
              <div formArrayName="comparativas" class="date-list">
                <div
                  *ngFor="let item of comparativas.controls; let i = index"
                  [formGroupName]="i"
                  class="date-row-group"
                >
                  <div class="card-title">
                    <lucide-icon name="Activity" [size]="18"></lucide-icon>
                    <h4>
                      Rangos de Fecha
                      <span
                        class="custom-tooltip-trigger"
                        data-tooltip="El rango máximo de selección es de 2 años."
                      >
                        <i class="info-icon-circle">i</i>
                      </span>
                    </h4>
                    <div class="ml-auto" title="Cambiar vista" (click)="switchCalendar()">
                      <lucide-icon
                        style="cursor: pointer"
                        name="list-icon"
                        [size]="18"
                      ></lucide-icon>
                    </div>
                  </div>

                  <div class="input-grid">
                    <div class="field">
                      <label class="block mb-1 text-sm font-medium text-secondary">Inicio</label>
                      <p-datepicker
                        formControlName="inicio"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        (onSelect)="onDateChange(i, 'inicio'); clearDateRangeYearWarning()"
                        (onYearChange)="onInicioYearChange($event, i)"
                        (onMonthChange)="onInicioMonthChange($event, i)"
                        (onClose)="clearDateRangeYearWarning()"
                        iconDisplay="input"
                        [minDate]="minDate"
                        [maxDate]="comparativas.at(i).get('fin')?.value || maxDate"
                        placeholder="dd/mm/aaaa"
                        appendTo="body"
                        styleClass="w-full"
                      >
                      </p-datepicker>
                    </div>

                    <div class="field">
                      <label class="block mb-1 text-sm font-medium text-secondary">Fin</label>
                      <p-datepicker
                        formControlName="fin"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        (onSelect)="onDateChange(i, 'fin')"
                        [minDate]="comparativas.at(i).get('inicio')?.value || minDate"
                        [maxDate]="maxDate"
                        iconDisplay="input"
                        placeholder="dd/mm/aaaa"
                        appendTo="body"
                        styleClass="w-full"
                      >
                      </p-datepicker>
                      @if (showDateRangeYearWarning()) {
                        <small class="date-range-year-warning"
                          >El rango máximo permitido es de 2 años.</small
                        >
                      }
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="date-row-group">
                <div class="card-title mb-3">
                  <lucide-icon name="Activity" [size]="18"></lucide-icon>
                  <h4>Fecha</h4>
                  <div class="ml-auto" title="Cambiar vista" (click)="switchCalendar()">
                    <lucide-icon
                      data-tooltip="Cambiar a modo calendario"
                      style="cursor: pointer"
                      name="calendar"
                      [size]="18"
                    >
                    </lucide-icon>
                  </div>
                </div>
                <div class="field">
                  <label class="block mb-1 text-sm font-medium text-secondary"></label>
                  <p-select
                    [options]="predefinedDateOptions"
                    formControlName="predefineDateOption"
                    optionLabel="label"
                    placeholder="Seleccione suministro"
                    class="w-full custom-select"
                    (onChange)="applyConfig()"
                    appendTo="body"
                  >
                    <ng-template #selectedItemDate let-selectedOption2>
                      <div class="flex align-items-center gap-2" *ngIf="selectedOption2">
                        <lucide-icon name="Droplets" [size]="14"></lucide-icon>
                        <span>{{ selectedOption2.label }}</span>
                      </div>
                    </ng-template>
                  </p-select>
                </div>
              </div>
            }
          </section>

          @if (this.configForm.controls['supplyType']?.value?.supplyTypeId != 14) {
            <div class="summary-card">
              <div class="card-title">
                <lucide-icon name="Activity" [size]="18"></lucide-icon>
                <h4>Resumen de la búsqueda</h4>
              </div>

              <div class="summary-rows">
                <div class="s-row">
                  <span class="s-label">Consumo medio del período</span>
                  <span class="s-value">{{ resumen.avg }} {{ resumen.units }}</span>
                </div>

                <div class="s-row-complex">
                  <div class="s-label">Consumo máximo:</div>
                  <div class="s-sublabel">{{ resumen.maxLabel }}</div>
                  <div class="s-value">{{ resumen.maxV }} {{ resumen.units }}</div>
                </div>

                <div class="s-row-complex">
                  <div class="s-label">Consumo mínimo:</div>
                  <div class="s-sublabel">{{ resumen.minLabel }}</div>
                  <div class="s-value">{{ resumen.minV }} {{ resumen.units }}</div>
                </div>

                <div class="s-row total">
                  <span class="s-label">Consumo total del período</span>
                  <span class="s-value">{{ resumen.total }} {{ resumen.units }}</span>
                </div>
              </div>
            </div>
          }

          @if (this.configForm.controls['supplyType']?.value?.supplyTypeId == 14) {
            @if (this.configForm.controls['formatType']?.value == 'Consumo individual') {
              <div class="summary-card">
                <div class="card-title">
                  <lucide-icon name="Activity" [size]="18"></lucide-icon>
                  <h4>Resumen de la búsqueda</h4>
                </div>

                <div class="summary-rows">
                  <div class="s-row">
                    <span class="s-label">Consumo medio del período</span>
                    <span class="s-value">{{ resumen.avg }} {{ resumen.units }}</span>
                  </div>

                  <div class="s-row-complex">
                    <div class="s-label">Consumo máximo:</div>
                    <div class="s-sublabel">{{ resumen.maxLabel }}</div>
                    <div class="s-value">{{ resumen.maxV }} {{ resumen.units }}</div>
                  </div>

                  <div class="s-row-complex">
                    <div class="s-label">Consumo mínimo:</div>
                    <div class="s-sublabel">{{ resumen.minLabel }}</div>
                    <div class="s-value">{{ resumen.minV }} {{ resumen.units }}</div>
                  </div>

                  <div class="s-row total">
                    <span class="s-label">Consumo total del período</span>
                    <span class="s-value">{{ resumen.total }} {{ resumen.units }}</span>
                  </div>
                </div>
              </div>
            }
            @if (this.configForm.controls['formatType']?.value != 'Consumo individual') {
              <div class="summary-card">
                <div class="card-title">
                  <lucide-icon name="Activity" [size]="18"></lucide-icon>
                  <h4>Resumen de la búsqueda</h4>
                </div>

                <div class="summary-rows">
                  <div class="s-row">
                    <span class="s-label">Consumo medio del período</span>
                    <span class="s-value"
                      >{{ resumenDistributed.avg }} {{ resumenDistributed.units }}</span
                    >
                  </div>

                  <div class="s-row-complex">
                    <div class="s-label">Consumo máximo:</div>
                    <div class="s-sublabel">{{ resumenDistributed.maxLabel }}</div>
                    <div class="s-value">
                      {{ resumenDistributed.maxV }} {{ resumenDistributed.units }}
                    </div>
                  </div>

                  <div class="s-row-complex">
                    <div class="s-label">Consumo mínimo:</div>
                    <div class="s-sublabel">{{ resumenDistributed.minLabel }}</div>
                    <div class="s-value">
                      {{ resumenDistributed.minV }} {{ resumenDistributed.units }}
                    </div>
                  </div>

                  <div class="s-row total">
                    <span class="s-label">Consumo total del período</span>
                    <span class="s-value"
                      >{{ resumenDistributed.total }} {{ resumenDistributed.units }}</span
                    >
                  </div>
                </div>
              </div>
            }
          }

          <div class="action-footer">
            @if (showCalendar) {
              <p-button
                severity="secondary"
                outlined="true"
                label="Limpiar"
                (onClick)="resetConfig()"
                class="w-100"
                styleClass="w-100 btn-clear-filters"
                [style]="{ width: '100%' }"
              />

              <span
                pTooltip="Por favor, seleccione un rango de fechas válido."
                [tooltipDisabled]="!configForm.invalid"
                tooltipPosition="top"
              >
                <p-button
                  severity="primary"
                  outlined="true"
                  label="Aplicar filtros"
                  [disabled]="configForm.invalid"
                  (onClick)="applyConfig()"
                  class="w-100"
                  styleClass="w-100 btn-apply-filters"
                  [style]="{ width: '100%' }"
                />
              </span>
            }
          </div>
        </div>
        @if (initialLoading()) {
          <div class="readings-config-skeleton-overlay config-skeleton" aria-busy="true">
            <div class="config-skeleton-header">
              <p-skeleton shape="circle" size="20px" />
              <p-skeleton width="65%" height="16px" />
            </div>
            <div class="config-skeleton-section">
              <p-skeleton width="55%" height="12px" styleClass="mb-2" />
              <p-skeleton width="100%" height="38px" borderRadius="6px" />
            </div>
            <div class="config-skeleton-section">
              <p-skeleton width="55%" height="12px" styleClass="mb-2" />
              <p-skeleton width="100%" height="38px" borderRadius="6px" />
            </div>
            <div class="config-skeleton-date-block">
              <p-skeleton width="65%" height="16px" styleClass="mb-3" />
              <p-skeleton width="100%" height="38px" borderRadius="6px" />
            </div>
            <div class="config-skeleton-summary">
              <p-skeleton width="65%" height="16px" styleClass="mb-3" />
              @for (row of [1, 2, 3]; track row) {
                <div class="config-skeleton-summary-row" aria-hidden="true">
                  <p-skeleton width="70%" height="12px" />
                  <p-skeleton width="80px" height="14px" />
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    @if (configForm.controls['formatType'].value !== 'Consumo desglosado') {
      <div class="mt-3 mb-3 readings-table-wrap">
        <p-card class="mt-xl-0 my-xl-0 readings-table-card">
          <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div class="fw-bold fs-5">Listado de consumos y lecturas</div>
            <p-splitbutton
              label="Exportar"
              icon="pi pi-download"
              [model]="exportMenuItems"
              [disabled]="exportDisabled()"
              severity="secondary"
              outlined="true"
              size="small"
              expandAriaLabel="Elegir formato de exportación"
              appendTo="body"
              (onClick)="exportConsumptions('csv')"
            />
          </div>

          @if (initialLoading()) {
            <div class="readings-table-skeleton-overlay skeleton-table" aria-busy="true">
              <div class="skeleton-table-header readings-table-row-4" aria-hidden="true">
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
              </div>
              @for (row of [1, 2, 3, 4, 5, 6]; track row) {
                <div class="skeleton-table-row readings-table-row-4" aria-hidden="true">
                  <p-skeleton width="75%" height="12px" />
                  <p-skeleton width="75%" height="12px" />
                  <p-skeleton width="75%" height="12px" />
                  <p-skeleton width="75%" height="12px" />
                </div>
              }
            </div>
          }

          <p-table
            #consumptionTable
            [value]="consumptionsTable()"
            stripedRows
            [scrollable]="consumptionsTableScrollable"
            [scrollHeight]="consumptionsTableScrollHeight"
            [size]="'small'"
            [tableStyle]="consumptionsTableStyle"
            [styleClass]="consumptionsTableStyleClass"
            [rowsPerPageOptions]="consumptionsTableRowsPerPageOptions"
            [paginator]="true"
            [rows]="rows"
            [first]="first"
            [lazy]="true"
            sortField="consumptionDate"
            [sortOrder]="-1"
            [showCurrentPageReport]="consumptionsTableShowCurrentPageReport"
            [showPageLinks]="consumptionsTableShowPageLinks"
            [showFirstLastIcon]="consumptionsTableShowFirstLastIcon"
            [paginatorStyleClass]="consumptionsTablePaginatorStyleClass"
            (onLazyLoad)="loadConsumptionsLazy($event)"
            [totalRecords]="totalRecords()"
            currentPageReportTemplate="{last} de {totalRecords}"
          >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width: 25%" pSortableColumn="consumptionDate" field="consumptionDate">
                  Fecha
                  <p-sortIcon field="consumptionDate" />
                </th>
                <th
                  style="width: 25%"
                  class="text-center"
                  pSortableColumn="readingValue"
                  field="readingValue"
                >
                  @if (isNarrowViewport()) {
                    Lect.
                  } @else {
                    Lectura {{ consumptionsUnits() }}
                  }
                  <p-sortIcon field="readingValue" />
                </th>
                <th
                  style="width: 25%"
                  class="text-center"
                  pSortableColumn="consumptionValue"
                  field="consumptionValue"
                >
                  @if (isNarrowViewport()) {
                    Cons.
                  } @else {
                    Consumo {{ consumptionsUnits() }}
                  }
                  <p-sortIcon field="consumptionValue" />
                </th>
                <th style="width: 25%" class="text-center">Tipo lectura</th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-consumption
              let-columns="columns"
              let-rowIndex="rowIndex"
            >
              <tr [pSelectableRow]="consumption" [pSelectableRowIndex]="rowIndex">
                <td
                  class="text-break"
                  [class.readings-table-td-fixed]="useFixedConsumptionsTableRowHeight()"
                >
                  {{ dateSpanishFormat(consumption.consumptionDate) }}
                </td>
                <td
                  class="text-break text-center"
                  [class.readings-table-td-fixed]="useFixedConsumptionsTableRowHeight()"
                >
                  {{ spanishFormat(consumption.readingValue) }}
                </td>
                <td
                  class="text-break text-center"
                  [class.readings-table-td-fixed]="useFixedConsumptionsTableRowHeight()"
                >
                  {{ spanishFormat(consumption.consumptionValue) }}
                </td>
                <td
                  class="text-break text-center"
                  [class.readings-table-td-fixed]="useFixedConsumptionsTableRowHeight()"
                >
                  {{ formatReadingType(consumption.readingType) }}
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="4">Ningun resultado encontrado.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>
    } @else {
      <div class="mt-3 mb-3 readings-table-wrap">
        <p-card class="mt-xl-0 my-xl-0 readings-table-card">
          <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div class="fw-bold fs-5">Listado de consumos y lecturas</div>
            <p-splitbutton
              label="Exportar"
              icon="pi pi-download"
              [model]="exportMenuItems"
              [disabled]="exportDisabled()"
              severity="secondary"
              outlined="true"
              size="small"
              expandAriaLabel="Elegir formato de exportación"
              appendTo="body"
              (onClick)="exportConsumptions('csv')"
            />
          </div>

          @if (initialLoading()) {
            <div class="readings-table-skeleton-overlay skeleton-table" aria-busy="true">
              <div class="skeleton-table-header readings-table-row-3" aria-hidden="true">
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
                <p-skeleton width="75%" height="12px" />
              </div>
              @for (row of [1, 2, 3, 4, 5, 6]; track row) {
                <div class="skeleton-table-row readings-table-row-3" aria-hidden="true">
                  <p-skeleton width="75%" height="12px" />
                  <p-skeleton width="75%" height="12px" />
                  <p-skeleton width="75%" height="12px" />
                </div>
              }
            </div>
          }

          <p-table
            #consumptionTable
            [value]="consumptionsTableByMeter()"
            stripedRows
            [scrollable]="consumptionsByMeterTableScrollable"
            [scrollHeight]="consumptionsByMeterTableScrollHeight"
            [size]="'small'"
            [tableStyle]="consumptionsByMeterTableStyle"
            [styleClass]="consumptionsByMeterTableStyleClass"
            [rowsPerPageOptions]="consumptionsByMeterTableRowsPerPageOptions"
            [paginator]="true"
            [rows]="rows"
            [first]="first"
            [lazy]="true"
            sortField="meterId"
            [sortOrder]="1"
            [showCurrentPageReport]="consumptionsByMeterTableShowCurrentPageReport"
            [showPageLinks]="consumptionsByMeterTableShowPageLinks"
            [showFirstLastIcon]="consumptionsByMeterTableShowFirstLastIcon"
            [paginatorStyleClass]="consumptionsByMeterTablePaginatorStyleClass"
            (onLazyLoad)="loadConsumptionsLazyDistributedByMeter($event)"
            [totalRecords]="totalRecords()"
            currentPageReportTemplate="{last} de {totalRecords}"
          >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th style="width: 33%" pSortableColumn="meterId" field="meterId">
                  @if (isNarrowViewport()) {
                    Nº cont.
                  } @else {
                    Nº de contador
                  }
                  <p-sortIcon field="meterId" />
                </th>
                <th
                  style="width: 33%"
                  class="text-center"
                  pSortableColumn="meterLocation"
                  field="meterLocation"
                >
                  @if (isNarrowViewport()) {
                    Loc.
                  } @else {
                    Localización
                  }
                  <p-sortIcon field="meterLocation" />
                </th>
                <th
                  style="width: 33%"
                  class="text-center"
                  pSortableColumn="consumptionValueTotal"
                  field="consumptionValueTotal"
                >
                  @if (isNarrowViewport()) {
                    Cons.
                  } @else {
                    Consumo {{ consumptionsUnits() }}
                  }
                  <p-sortIcon field="consumptionValueTotal" />
                </th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-consumption
              let-columns="columns"
              let-rowIndex="rowIndex"
            >
              <tr [pSelectableRow]="consumption" [pSelectableRowIndex]="rowIndex">
                <td
                  class="text-break"
                  [class.readings-table-td-fixed]="useFixedConsumptionsByMeterTableRowHeight()"
                >
                  {{ consumption.meterId }}
                </td>
                <td
                  class="text-break text-center"
                  [class.readings-table-td-fixed]="useFixedConsumptionsByMeterTableRowHeight()"
                >
                  {{ consumption.meterLocation }}
                </td>
                <td
                  class="text-break text-center"
                  [class.readings-table-td-fixed]="useFixedConsumptionsByMeterTableRowHeight()"
                >
                  {{ spanishFormat(consumption.consumptionValueTotal) }}
                </td>
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td colspan="3">Ningun resultado encontrado.</td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>
    }
  </main>
</div>
